import WheelDetails from './wheel_details'
export * from './wheel_details'

export default WheelDetails